import { z } from "zod";

export const serviceTopologyRoleValues = [
  "frontend",
  "backend",
  "database",
  "service",
  "library",
  "unknown",
] as const;

export const serviceTopologyEntrySchema = z.object({
  dependsOn: z.array(z.string()),
  exposedPort: z.number().nullable(),
  framework: z.string().nullable(),
  localDevCommand: z.string().nullable(),
  primaryLanguage: z.string().nullable(),
  role: z.enum(serviceTopologyRoleValues),
  runAsService: z.boolean(),
  slug: z.string(),
});

export type ServiceTopologyEntry = z.infer<typeof serviceTopologyEntrySchema>;

export const serviceTopologySourceValues = ["graph", "chat_fallback"] as const;

export const serviceTopologySchema = z.object({
  resolvedAt: z.number(),
  services: z.array(serviceTopologyEntrySchema),
  source: z.enum(serviceTopologySourceValues),
  suggestedTargetUrl: z.string().nullable(),
});

export type ServiceTopology = z.infer<typeof serviceTopologySchema>;

const TOPOLOGY_TAG_OPEN = "<topology_json>";
const TOPOLOGY_TAG_CLOSE = "</topology_json>";

export function parseServiceTopologyFromText(
  text: string,
): ServiceTopology | null {
  const openIndex = text.indexOf(TOPOLOGY_TAG_OPEN);
  if (openIndex === -1) {
    return null;
  }

  const jsonStart = openIndex + TOPOLOGY_TAG_OPEN.length;
  const closeIndex = text.indexOf(TOPOLOGY_TAG_CLOSE, jsonStart);
  if (closeIndex === -1) {
    return null;
  }

  const jsonText = text.slice(jsonStart, closeIndex).trim();
  if (!jsonText) {
    return null;
  }

  try {
    const parsed: unknown = JSON.parse(jsonText);
    const result = serviceTopologySchema.safeParse(parsed);
    return result.success ? result.data : null;
  } catch {
    return null;
  }
}
